import { IconSVGProps } from '../types'

export const LinkIcon = ({ className, fill }: IconSVGProps) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5325 9.51807L10.5253 8.51084L11.5325 7.50362C12.9232 6.11294 12.9232 3.85816 11.5325 2.46747C10.1419 1.07677 7.88705 1.07677 6.49637 2.46747L5.48914 3.4747L4.48191 2.46747L5.48914 1.46023C7.43614 -0.486744 10.5928 -0.486744 12.5398 1.46023C14.4867 3.40721 14.4867 6.56385 12.5398 8.51084L11.5325 9.51807ZM9.51803 11.5326L8.51081 12.5398C6.56389 14.4867 3.4072 14.4867 1.46023 12.5398C-0.486743 10.5928 -0.486743 7.4361 1.46023 5.48916L2.46745 4.48193L3.47469 5.48916L2.46745 6.4964C1.07676 7.88708 1.07676 10.1418 2.46745 11.5326C3.85815 12.9233 6.11291 12.9233 7.50359 11.5326L8.51081 10.5253L9.51803 11.5326ZM9.01442 3.97832L10.0217 4.98555L4.98553 10.0217L3.9783 9.01446L9.01442 3.97832Z" />
  </svg>
)
